import React, { useCallback, useMemo } from 'react';

import { Grid, GridItem } from '@chakra-ui/react';
import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { useOKRAccessControl } from 'components/RabbitOKRSidePanel/AccessControl/useOKRAccessControl';
import { updateLocalStateValues } from 'components/RabbitOKRSidePanel/KRslice';
import { OKRTags } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Details/OKRTags';
import { useOKRTagsQuery } from 'components/RabbitOKRSidePanel/datahooks/useGetCustomTagsOrganization';
import { useSelector, useDispatch } from 'react-redux';
import { kRDrawerSelector } from 'selectors/kRDrawer';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

import { isMobileView } from 'constants/isMobileView';

import { TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  isEditOKR?: boolean;
}

const TagsSection = ({ isEditOKR }: Props) => {
  const dispatch = useDispatch();
  const createOKRDetails = useSelector(okrCreationPanelStateSelector);
  const editOKRSavedDetails = useSelector(kRDrawerSelector);
  const editOKRDetails = useMemo(
    () => ({ ...editOKRSavedDetails, ...editOKRSavedDetails.localStateValues }),
    [editOKRSavedDetails]
  );
  const okrDetails = isEditOKR ? editOKRDetails : createOKRDetails;

  const { tagKeyList = [] } = okrDetails;
  const { data: tagKeyListFromApi = [] } = useOKRTagsQuery({ okrId: editOKRDetails?.uuid });
  const customTags = isEditOKR ? editOKRSavedDetails?.localStateValues?.tagKeyList || tagKeyListFromApi : tagKeyList;
  const isTagEditionInSidePanelChildCreation = !isEditOKR && editOKRDetails?.uuid;
  const { canEditOKR } = useOKRAccessControl();

  const onChange = useCallback(
    (updates) => {
      dispatch(isEditOKR ? updateLocalStateValues(updates) : updateOKR(updates));
    },
    [dispatch, isEditOKR]
  );

  return (
    // @ts-expect-error: union too complex
    <Grid gridTemplateColumns={isMobileView() ? '25% 4% 71%' : '20% 4% 76%'} alignItems="center" mb="16px">
      <GridItem>
        <TextLabel color="text.g2">Tags:</TextLabel>
      </GridItem>
      {/* For spacing after first column */}
      <GridItem />
      <GridItem
        sx={{
          '#tag-container': {
            paddingLeft: '0px !important',
          },
        }}
      >
        <OKRTags
          // @ts-expect-error: expected params type
          onChange={(tags) => {
            console.log('tags', tags);
            onChange({ tagKeyList: tags });
          }}
          okrId={editOKRDetails?.uuid}
          tags={customTags}
          containerProps={{ maxWidth: '408px' }}
          showNewTagCreation
          isTagEditionAsChild
          isTagEditionInSidePanelChildCreation={isTagEditionInSidePanelChildCreation}
          isReadOnly={!canEditOKR && isEditOKR}
          isSendUpdatedTagsToParent={isEditOKR}
        />
      </GridItem>
    </Grid>
  );
};

export { TagsSection };
